import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    isSuggestedSendingEmailRow,
    type SendingEmailRow,
} from "../sendingEmailsViewConfig";

export const DisplayNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, SendingEmailRow, string | null>) => (
        <ViewTableCell>
            {isSuggestedSendingEmailRow(row.original)
                ? null
                : (row.original.displayName ?? "-")}
        </ViewTableCell>
    ),
);
